module.exports = __webpack_public_path__ + "img/1.3675ae61.svg";